import * as tslib_1 from "tslib";
import { RelevanceFormControl } from "../controls/relevance-form-control";
import { H3Avatar, H3Button, H3Checkbox } from "h3-mobile-vue";
import { Component, Model, Prop, Vue, Watch } from "vue-property-decorator";
import SearchPanel from "./search-panel.vue";
let RelevanceFormModal2 = class RelevanceFormModal2 extends Vue {
    constructor() {
        super(...arguments);
        this.queryConditions = [];
        this.queryColumns = [];
        this.select = [];
        this.selectData = [];
    }
    get searchFormula() {
        let _searchFormula = this.control && this.control.options.searchFormula;
        return _searchFormula ? JSON.parse(_searchFormula).conditions : [];
    }
    onVisibleChange() {
        if (this.visible) {
            this.getListQueryConditions().then((res) => {
                try {
                    // 如果配置了查询条件，使用配置的，如果没有就使用关联目标视图中配置的查询条件
                    let conditions = JSON.parse(this.control.options.conditions);
                    if (conditions.$queryData) {
                        //将返回queryConditions数据更多信息赋值给res.data.queryConditions
                        (conditions.$queryData).forEach((ele) => {
                            let Item = res.conditions && (res.conditions).find((item) => {
                                return ele.propertyCode === item.propertyCode;
                            }) || {};
                            for (let con of this.query) {
                                if (con.code === ele.propertyCode) {
                                    ele.defaultValue = con.value;
                                }
                            }
                            ele = Object.assign(ele, Item);
                        });
                        res.conditions = conditions.$queryData;
                    }
                }
                catch (error) {
                }
                if (res) {
                    this.queryConditions = res.conditions;
                    this.queryColumns = res.queryColumns;
                }
                else {
                    this.queryConditions = [];
                }
            });
            const searchPanel = this.$refs.searchPanel;
            if (searchPanel) {
                searchPanel.reFetch();
            }
        }
    }
    getListQueryConditions() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (!RelevanceFormControl.service.getListQueryConditions) {
                return Promise.reject(null);
            }
            let queryCode = "";
            queryCode = this.queryCode || "";
            const schemaCode = this.schemaCode || "";
            return yield RelevanceFormControl.service.getListQueryConditions(schemaCode, queryCode, this.query);
        });
    }
    isSelected(item) {
        if (!this.value || !item) {
            return false;
        }
        return this.value.id === item.id;
    }
    back() {
        this.$emit("back");
        this.selectData = [];
        this.select = [];
    }
    ok() {
        const backData = this.selectData.map(res => {
            return res.data;
        });
        this.$emit("change", backData);
        this.selectData = [];
        this.select = [];
    }
    getCreater(item) {
        if (Array.isArray(item.creater)) {
            if (item.creater.length > 0) {
                return item.creater[0];
            }
        }
        return {};
    }
    fetch(page, pageSize, value, queryData = [], mobile) {
        const schemaCode = this.schemaCode || "";
        let queryCode = this.queryCode || "";
        const params = queryData ? [] : [];
        params.push({
            code: "name",
            type: 0,
            value
        });
        // 添加关联表单限定条件
        this.searchFormula.forEach((el) => {
            queryData.push({
                propertyCode: el.propertyCode,
                propertyType: el.propertyType,
                propertyValue: typeof el.value === "string" ? el.value : JSON.stringify(el.value),
                operatorType: el.operatorType,
            });
        });
        // const _ctrl = this.ctrl as any;
        // const cols = this.columns;
        return RelevanceFormControl.service.search(schemaCode, queryCode, params, this.columns, page, pageSize, queryData);
    }
    change(item) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const idx = this.select.indexOf(item.id);
            if (idx > -1) {
                this.select.splice(idx, 1);
                this.selectData.slice(idx, 1);
            }
            else {
                this.select.push(item.id);
                this.selectData.push(item);
            }
            // item = await this.convertForMappings(item.data);
        });
    }
    superFetch(page, pageSize, value, formState) {
        let query = [];
        if (formState) {
            query = [formState];
        }
        else {
            query = this.queryFormData;
        }
        return this.fetch(page, pageSize, value, query, true);
    }
    getStatus(status) {
        const txt = this.$t(`cloudpivot.form.renderer.formStatus.${status.toLowerCase()}`);
        return txt;
        // switch (status) {
        //   case "DRAFT":
        //     return "草稿";
        //   case "PROCESSING":
        //     return "进行中";
        //   case "COMPLETED":
        //     return "已完成";
        //   case "CANCELED":
        //     return "已作废";
        //   default:
        //     return "";
        // }
    }
    showFilterPanel(show) {
        //   if(show){
        //     this.getListQueryConditions().then(res => {
        //       this.queryConditions = res || [];
        //     });
        //   }
    }
    onFilter(query) {
        // this.queryFormData = query.map(x => ({
        //   code : x.propertyCode,
        //   type : x.propertyType,
        //   value : x.propertyValue
        // }));
        this.queryFormData = query;
        const searchPanel = this.$refs.searchPanel;
        if (searchPanel) {
            searchPanel.reFetch();
        }
    }
    beforeCreate() {
        this
            .$options.components.FormStatus = RelevanceFormControl.loadFormStatus();
        this
            .$options.components.QueryForm = RelevanceFormControl.loadQueryForm();
        this
            .$options.components.FormItem = RelevanceFormControl.loadFormItem();
    }
};
tslib_1.__decorate([
    Prop({
        default: false
    })
], RelevanceFormModal2.prototype, "visible", void 0);
tslib_1.__decorate([
    Prop({})
], RelevanceFormModal2.prototype, "control", void 0);
tslib_1.__decorate([
    Model("change")
], RelevanceFormModal2.prototype, "value", void 0);
tslib_1.__decorate([
    Prop()
], RelevanceFormModal2.prototype, "schemaCode", void 0);
tslib_1.__decorate([
    Prop()
], RelevanceFormModal2.prototype, "queryCode", void 0);
tslib_1.__decorate([
    Prop({
        default: []
    })
], RelevanceFormModal2.prototype, "query", void 0);
tslib_1.__decorate([
    Prop({
        default: []
    })
], RelevanceFormModal2.prototype, "columns", void 0);
tslib_1.__decorate([
    Watch("visible")
], RelevanceFormModal2.prototype, "onVisibleChange", null);
RelevanceFormModal2 = tslib_1.__decorate([
    Component({
        name: "relevance-form-modal",
        components: {
            SearchPanel,
            H3CheckboxItem: H3Checkbox.Item,
            H3Avatar,
            H3Button
            // FormItem: list.components.mobile.FormItem
        },
        directives: {
        // TransferDom
        }
    })
], RelevanceFormModal2);
export default RelevanceFormModal2;
